<template>
  <div>
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        编辑案例
      </div>
      <div class="mt-6">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="案例标题" class="w-2/4">
            <el-input v-model="form.case_title"></el-input>
          </el-form-item>
          <el-form-item label="案例类型" class="w-2/4">
            <el-input v-model="form.case_type"></el-input>
          </el-form-item>
          <el-form-item label="案例分类">
            <el-select
              v-model="value"
              placeholder="请选择分类"
              @change="dropdownChange"
            >
              <el-option
                v-for="item in cateList"
                :key="item.caseCates_id"
                :label="item.cateName"
                :value="item.caseCates_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="!cateChange">
            <el-form-item label="静图上传">
              <el-upload
                :action="uploadUrl"
                name="image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-success="handleSuccess"
                :on-error="handleError"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="动图上传">
              <el-upload
                :action="uploadUrl"
                name="image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-success="handleSuccess2"
                :on-error="handleError"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="二维码上传">
              <el-upload
                :action="uploadUrl"
                name="image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-success="handleSuccess3"
                :on-error="handleError"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </div>
          <div v-if="cateChange">
            <el-form-item label="网站说明" class="w-2/4">
              <el-input v-model="form.webExplain"></el-input>
            </el-form-item>
            <el-form-item label="行业类型" class="w-2/4">
              <el-input v-model="form.hangyeCate"></el-input>
            </el-form-item>
            <el-form-item label="项目背景" class="w-2/4">
              <el-input v-model="form.projectContext"></el-input>
            </el-form-item>
            <el-form-item label="头图上传">
              <el-upload
                :action="uploadUrl"
                name="image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-success="handleSuccesstoutu"
                :on-error="handleError"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload><div>
                *温馨提示：请上传1600:900的图片
              </div>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="长图上传">
              <el-upload
                :action="uploadUrl"
                name="image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-success="handleSuccessgwimages"
                :on-error="handleError"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="submitForm(form)">编辑</el-button>

          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() {
    this.uploadUrl = this.$api.defaults.baseURL + "/Image/upload2";
    this.getCates();
    this.case_id = this.$route.query.case_id
    this.getCateInfo(this.case_id);
  },
  data() {
    return {
      cateChange: false,
      case_id:'',
      cateList: [],
      cateName: "",
      value: "",
      uploadUrl: "",
      form: {
        case_title: "",
        case_img: "",

        add_time: "",
        case_type: "",
        case_img2: "",
        case_img3: "",
        cateName: "",
        webExplain: "", //网站说明,
        hangyeCate:'',//pc行业类型
        toutu: "", //头图
        gwimages: "", //长图
        projectContext:''//项目背景
      },

      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  methods: {

    //根据case_id查询
    getCateInfo(case_id){
      axios.get(`/caseIndex3?case_id=${case_id}`).then(({data})=>{
         if(data.code == 200){
          this.form = data.data[0];
          this.value = data.data[0].cateName;
         }

      })
    },
    //x下拉变化
    dropdownChange(e) {
      if (e == 3) {

        this.cateChange = true;
        this.form.cateName = e;

      } else {
        this.cateChange = false;
        this.form.cateName = e;

      }
    },
    //获取分类
    getCates() {
      axios.get("/cateIndex").then(({ data }) => {
        if (data.code == 200) {

          this.cateList = data.data;

        } else {
          this.$message({
            type: "warning",
            message: "获取失败！"
          });
        }
      });
    },
    //长图
    handleSuccessgwimages(response) {

      this.form.gwimages = this.$api.defaults.baseURL + response.data.url;

    },
    //头图
    handleSuccesstoutu(response) {
      this.form.toutu = this.$api.defaults.baseURL + response.data.url;
    },
    handleSuccess(response) {
      this.form.case_img = this.$api.defaults.baseURL + response.data.url;
    },
    handleSuccess2(response) {
      this.form.case_img2 = this.$api.defaults.baseURL + response.data.url;
    },
    handleSuccess3(response) {
      this.form.case_img3 = this.$api.defaults.baseURL + response.data.url;
    },
    handleError(error) {},
    handleChange(file, fileList) {},
    submitForm(form) {
      const time = this.$funs.getTime();
      this.form.add_time = time;

      axios
        .post("/updateCase/"+this.case_id, form)
        .then(({ data }) => {
         if(data.code==200){
          this.$message({
             type: "success",
             message:data.message

          })
          this.$router.push({path:'/caseList'})
         }else{
          this.$message({
             type: "warning",
             message:data.message

          })

         }


        })
        .catch(err => {});
    },
    resetForm(form) {
      this.form = {};
    },
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/case/updateCase.vue